import { PhotoIcon } from '@heroicons/react/24/solid'

const ProductImageDisplay = ({ imageUrl }) => (
  <div className="mt-8">
    <label className="block text-sm font-medium text-gray-600 mb-6">Product Image</label>
    <div className="bg-neutral-200-100 flex justify-center items-center px-6 py-10 border border-gray-300 rounded-md text-center">
      {imageUrl ? (
        <img src={imageUrl} alt="Preview" className="mx-auto max-h-32 w-auto rounded" />
      ) : (
        <div className="flex flex-col items-center justify-center gap-1 text-center">
          <PhotoIcon className="text-gray-400 w-8 h-8" />
          <span className="text-gray-500">Product image</span>
        </div>
      )}
    </div>
  </div>
)

export default ProductImageDisplay
